import { useState } from "react";
import { Container, Button, Spinner } from "react-bootstrap";
import "../../../assets/css/customer/screens/home/Booking.css";
import { useNavigate } from "react-router-dom";

const EstaticeBookingCTA = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const handleBook = () => {
      setLoading(true);
      navigate("/customer/book");
    };

  return (
    <section className="ac-cta">
      <Container className="ac-cta__container">
        <div className="ac-cta__card">
          <h2 className="ac-cta__heading">Book your skin consultation today</h2>
          <p className="ac-cta__desc">
            A 30-minute consultation with our dermatologists to map a treatment
            plan tailored to your skin.
          </p>
          <Button
            className="ac-cta__btn"
            onClick={handleBook}
            disabled={loading}
          >
            {loading ? (
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
            ) : (
              "Book Appointment"
            )}
          </Button>
        </div>
      </Container>
    </section>
  );
};

export default EstaticeBookingCTA;